import Vue from "vue";
import { BootstrapVue, IconsPlugin, VBScrollspyPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/style.css";
import "@/assets/cfuser.css";
import "@/assets/scoreboard.css";

import App from "./App.vue";
import router from "@/router";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VBScrollspyPlugin);
Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
